module.exports = __webpack_public_path__ + "img/bigframe.8fdd4f8a.jpg";